import { render, staticRenderFns } from "./SuppliesBar.vue?vue&type=template&id=60aec2ea"
import script from "./SuppliesBar.vue?vue&type=script&lang=js"
export * from "./SuppliesBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports